<template>
	<div class="company_page">
		<!-- ヘッダー -->
		<headerBar></headerBar>
		<div class="image_area" :style="{'background-image':'url(' + bgimage + ')'}"></div>
		<!-- 挨拶 -->
		<div class="comment_area">
			<a id="comment"/>
			<div class="title">ご挨拶</div>
			<div><div class="faceimage_area"><img class="faceimage" src="@/assets/face.jpg"/><div style="font-size:0.7rem; margin-top:-6px;">photo by <a href="https://mami-d.wixsite.com/kuon-photography" target="_blank" rel="noopener">deguchi-mami</a></div></div>
			近年、私達の身の回りでは目まぐるしい技術の発展により、子どもの頃に思い描いていた夢のような事が現実になっています。しかしこのような時代の変化に置いてけぼりになってしまう人も多くいます。また、一方では未来を担う子どもたちへもＩＴ化の重圧がのしかかり、新しい技術についていけない子どもたちが増えるかもしれません。<br>
				当社では、このような方々にも新しい世界を楽しんで頂けるにはどうすれば良いのかを常に考え、新しい未来とお客様の架け橋となれるよう日々取り組んでまいります。<br><br>
				ビーブリッヂは「新しい未来とあなたの架け橋に」をテーマとして、システム開発を通じ、皆さまのお役に立てるための努力をしてまいります。<br><br>
				皆さまのご理解とご支援を賜りますよう、よろしくお願い申し上げます。<br><br>
				<span style="font-weight: bold; float:right">株式会社ビーブリッヂ<br>
				代表取締役　橋本 哲郎</span>
			</div>
		</div>
		<!-- 会社概要 -->
		<div class="company_info">
			<div class="companyImage" :style="{'background-image':'url(' + companyImage + ')'}"></div>
			<a id="info"/>
			<div class="title">会社概要</div>
			<div class="list_area tbl">
				<div class="tblrow">
					<div class="subtitle tblcell">社名</div>
					<div class="tblcell">株式会社ビーブリッヂ</div>
				</div>
				<div class="tblrow">
					<div class="subtitle tblcell">代表者</div>
					<div class="tblcell">代表取締役　橋本 哲郎</div>
				</div>
				<div class="tblrow">
					<div class="subtitle tblcell">設立</div>
					<div class="tblcell">2018年9月14日</div>
				</div>
				<div class="tblrow">
					<div class="subtitle tblcell">資本金</div>
					<div class="tblcell">1,500,000円</div>
				</div>
				<div class="tblrow">
					<div class="subtitle tblcell">本社所在地</div>
					<div class="tblcell">〒802-0001<br>福岡県北九州市小倉北区浅野3丁目8番1号 AIMビル6F COMPASS小倉 215号（北九州テレワークセンター）</div>
				</div>
				<div class="tblrow">
					<div class="subtitle tblcell">事業内容</div>
					<div class="tblcell">システム開発 ／ ソフトウェア開発 ／ Webアプリケーション開発 ／ Webサイト制作 ／ 各種デザイン ／ システムコンサルタント</div>
				</div>
			</div>
		</div>
		<!-- サイトマップ -->
		<sitemap></sitemap>
	</div>
</template>

<script>
import Vue from 'vue'
import headerBar from '@/components/headerBar.vue'
import sitemap from '@/components/map.vue'
export default {
	name: 'companyPage',
	components: {
		'headerBar': headerBar,
		'sitemap': sitemap
	},
	data() {
		return {
			bgimage: require("@/assets/images/topSlide/image01.jpg"),
			companyImage: require("@/assets/images/company_bg.jpg")
		}
	},
	beforeRouteEnter(to, from ,next) {
		next(vm => {
			if (to.hash.match(/^#/)) {
				let anc = to.hash.replace(/^#/, '');
				vm.$scrollTo("#" + anc);
			} else {
				vm.$scrollTo("#app");
			}
		});
	},
	afterEach(to, from) {
		
	},
	watch: {
		'$route': function(n, o) {
			if (n.hash.match(/^#/)) {
				let anc = n.hash.replace(/^#/, '');
				this.$scrollTo("#" + anc);
			} else {
				this.$scrollTo("#app");
			}
		}
	}
}
</script>

<style lang="less" scoped>
.company_page {
	.image_area {
		width: 100%;
		height: 280px;
		background-size: cover;
		background-position: center;
	}
	
	.comment_area {
		padding: 60px 80px 20px 80px;
		background-color: #fff;
		
		.faceimage_area {
			float: left;
			margin-right: 12px;
			margin-bottom: 12px;
			width: 180px;
			height: 185px;
		}
		
		.faceimage {
			width: 180px;
		}
		
		a {
			color: #6A6A6A;
			text-decoration: none;
		}
	}
	
	.company_info {
		padding: 80px 80px 80px 80px;
		background-color: #fff;
		
		.companyImage {
			width: 100%;
			height: 260px;
			background-size: cover;
			background-position: center;
			margin-bottom: 60px;
		}
		
		.list_area {
			margin-top: 20px;
			margin-left: 60px;
			.tblcell {
				padding: 8px;
			}
			
			.subtitle {
				text-align: right;
				border-right: 1px solid #eb5f1a;
				min-width: 70px;
			}
		}
	}
	
	.title {
		font-size: 1.1rem;
		font-weight: bold;
		border-left: 8px solid #eb5f1a;
		border-bottom: 1px solid #eb5f1a;
		padding-left: 6px;
		margin-bottom: 10px;
	}
}

@media(max-width:420px) {
	.company_page {
		.comment_area {
			padding: 60px 28px;
		}
		
		.company_info {
			padding: 80px 28px;
			
			.list_area {
				margin-left: 0;
			}
		}
	}
}
</style>
